"use client";

import { setUserInteractionDataAttribute } from "@shared/constants";

import kebabToCamelCase from "@shared/functions/kebabToCamelCase";

import Field from "@client/components/formik/field";
import Input from "@client/components/formik/input";
import Fieldset from "@client/components/lead-form/components/fieldset";
import { useCMSOverride } from "@client/functions/custom-hooks/useCMSOverride";

import { FormButton } from "@ui/js/components/buttons/form-button";

interface Props {
  legendOverride?: string;
}

const INPUT_ID_AND_LABEL_HTMLFOR = "street-address";
const FIELD_NAME_SELECTOR = kebabToCamelCase(INPUT_ID_AND_LABEL_HTMLFOR);

export default function StreetAddress({ legendOverride }: Props) {
  const legendFallback = "What is your street address?";
  const legend = useCMSOverride(legendFallback, legendOverride);

  return (
    <>
      <Fieldset
        dialog="We request your address for three main reasons: to verify your identity, to conduct an accurate soft credit pull without affecting your score, and to match you with the best financial solutions. Your privacy is paramount to us; all data is encrypted and used with the utmost care."
        legend={legend}
      >
        <Field
          {...setUserInteractionDataAttribute(
            `lead-form_step_${INPUT_ID_AND_LABEL_HTMLFOR}`,
          )}
          id={INPUT_ID_AND_LABEL_HTMLFOR}
          name={FIELD_NAME_SELECTOR}
          label="Street Address"
        >
          <Input id={INPUT_ID_AND_LABEL_HTMLFOR} name={FIELD_NAME_SELECTOR} />
        </Field>
      </Fieldset>
      <FormButton
        {...setUserInteractionDataAttribute(
          `lead-form_submit-button_${INPUT_ID_AND_LABEL_HTMLFOR}`,
        )}
      />
    </>
  );
}
